import React, { useContext } from 'react';

let handleNavBarFunctionsandVariants: any = {
  handleNavFunctions: {
    handleReRouting: (_e: React.ChangeEvent<HTMLInputElement>) => {},
    handleDropDownState: (_e: React.ChangeEvent<HTMLInputElement>) => {},
    handleNavBarStateImgAndButton: (
      _e: React.ChangeEvent<HTMLInputElement>
    ) => {},
    handleNavBarRef: (_text: string) => {},
  },
  navLinkRef: <React.Fragment />,
  activeComponent: '',
  dropDownState: true,
  widthwindow: 0,
  locationDetails: [{}],
};

export const NavBarContext = React.createContext(
  handleNavBarFunctionsandVariants
);
export const useVariant = () => useContext(NavBarContext);
